import useLocale from "hooks/useLocale";
import { DefaultMDXProvider } from "../components/default-mdx-provider";
import * as TermsAr from "../content/ar/terms.mdx";
import * as TermsDe from "../content/de/terms.mdx";
import * as TermsEn from "../content/en/terms.mdx";
import * as TermsEs from "../content/es/terms.mdx";
import * as TermsFr from "../content/fr/terms.mdx";
import * as TermsRu from "../content/ru/terms.mdx";
import * as TermsZh from "../content/zh/terms.mdx";

const localeContents = {
  ar: TermsAr,
  de: TermsDe,
  en: TermsEn,
  es: TermsEs,
  fr: TermsFr,
  ru: TermsRu,
  zh: TermsZh,
} as const;

export default function Terms() {
  const locale = useLocale();
  const { default: Content, frontmatter } = localeContents[locale];

  return (
    <DefaultMDXProvider frontmatter={frontmatter}>
      <Content />
    </DefaultMDXProvider>
  );
}
